import React, { useEffect } from 'react';
import classNames from 'classnames';

import { Carousel } from 'components/Carousel';
import { utagLinkPDP } from 'features/tealium';
import { Button } from 'components/Button';
import { getThumbnailImage } from 'features/pixlee/helpers';
import { PixleeMediaModal } from 'features/pixlee/components';
import injectTurnToSpeedFlex from 'features/productReviews/injectTurnToSpeedFlex';
import initProductReviewFormTracking from 'features/productReviews/analytics/initProductReviewFormTracking';

import {
	albumDetailsForPDP,
	UGCEventTypes,
	widgetResponsiveConfig,
	slidesToSlideMobile,
	modalConfig
} from '../constants';
import { PixleeWidget } from '../components';
import './styles.scss';
import 'features/productReviews/components/ProductReviews.scss';

function PDPWidgetMobile ({
	productSku, showShopNextPrevButtonToggleOn, gaEvents, onLoadCallback
}) {

	useEffect(() => {

		// This should execute after carousel render elements
		setTimeout(() => {

			const PixleeMobileCarousel = document.querySelector('.PixleeMobileCarousel');
			const feedsCount = PixleeMobileCarousel && PixleeMobileCarousel.childElementCount;

			if (PixleeMobileCarousel && feedsCount <= 2) {

				PixleeMobileCarousel.style.transform = 'translate3d(0px, 0px, 0px)';

			}

		}, 2000);

	}, []);

	return (
		<PixleeWidget
			albumDetails={albumDetailsForPDP}
			productSku={productSku}
			UGCEventTypes={UGCEventTypes.pdp}
			remainingItemsToSlide={4}
			gaEvents={gaEvents}
			onLoadCallback={onLoadCallback}
		>
			{(
				updateModalProps,
				inViewRef,
				activeSlideIndex,
				list,
				beforeChange,
				modal,
				show,
				afterChange,
				initialModalSlideIndex
			) => (
				<>
					{list.isEmpty === false ? (
						<>
							<div ref={inViewRef}>
								<Carousel
									responsive={widgetResponsiveConfig}
									beforeChange={beforeChange}
									afterChange={afterChange}
									arrows={false}
									sliderClass="PixleeMobileCarousel"
									partialVisible
									slidesToSlide={slidesToSlideMobile}
									minimumTouchDrag={10}
								>
									{list.data.map((item, index) => (
										<button
											className="pdpWidgetSlideWrapper"
											tabIndex={0}
											onClick={updateModalProps(item, index)}
											onKeyDown={(e) => {

												if (e.key === 'Enter') {

													updateModalProps(item, index);

												}

											}}
										>
											<img
												aria-label="view Customer Photos"
												aria-haspopup="true"
												width={144}
												height={144}
												key={item.album_photo_id}
												src={getThumbnailImage(item)}
												alt=""
											/>
										</button>
									))}
								</Carousel>
							</div>

							{show && list.data && (
								<PixleeMediaModal
									activeSlideIndex={initialModalSlideIndex}
									albumDetails={albumDetailsForPDP}
									initialMedia={list}
									UGCEventTypes={UGCEventTypes.pdp}
									showShopNextPrevButtonToggleOn={showShopNextPrevButtonToggleOn}
									productSku={productSku}
									modal={modal}
									{...modalConfig.captions.product}
								/>
							)}
						</>
					) : list.isEmpty === true ? (
						<div>
							<p className="productReviews__emptyMessage">
								Share a photo! You can add up to five photos or videos.
							</p>

							<div className="productReviews__writeReviewBtnWrapper">
								<Button
									type="button"
									buttonStyleVariant="secondary"
									className={classNames('productReviews__writeReviewBtn, noReviews')}
									onClick={() => {

										injectTurnToSpeedFlex();
										utagLinkPDP('TurnTo')({
											eventAction: 'Click-WriteAReview',
											eventLabel: `${window.shortSku}`
										});
										window.TurnToCmd('reviewsList.writeReview');
										initProductReviewFormTracking();

									}}
								>
									Write a review
								</Button>
							</div>
						</div>
					) : (
						[]
					)}
				</>
			)}
		</PixleeWidget>
	);

}

export default PDPWidgetMobile;
